import React from 'react';

export const ColorBox = props => {
    const imageSrc = props.imageSrc;
    const color = props.color || `#${Math.random().toString(16).slice(2, 8)}`;
    const width = props.width || "32";
    const height = props.height || "32";

    return (
        <>
            {imageSrc && imageSrc.length > 0 ?
                <img className="bd-placeholder-img mr-2 rounded" src={imageSrc} width={width} height={height} alt="logo" />
                :
                <svg className="bd-placeholder-img mr-2 rounded" width={width} height={height} xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img">
                    <rect width="100%" height="100%" fill={color}></rect>
                </svg>
            }
        </>
    );
}